export default "__VITE_ASSET__O3Fs$VmA__"